import React from 'react';
import { MfWidgetRegistryContext, type WidgetRegistry } from '@brandclub/common-ui';

const registry: WidgetRegistry = {
  'order-history': React.lazy(() => import('concierge_widgets/OrderHistory')),
  'product-carousels': React.lazy(() => import('concierge_widgets/ProductCarousels')),
  'product-comparison': React.lazy(() => import('concierge_widgets/CompareProducts')),
  'store-locator': React.lazy(() => import('concierge_widgets/StoreLocator')),
  'featured-product': React.lazy(() => import('concierge_widgets/FeaturedProduct')),
  'product-highlight': React.lazy(() => import('concierge_widgets/ProductHighlight')),
  'daily-deals': React.lazy(() => import('concierge_widgets/DailyDeals')),
  'product-details': React.lazy(() => import('concierge_widgets/ProductDetails')),
};

export function MfWidgetRegistryProvider({ children }: { children: React.ReactNode }) {
  return (
    <MfWidgetRegistryContext.Provider value={registry}>
      {children}
    </MfWidgetRegistryContext.Provider>
  );
}
